define('banner/custom-banners/settings',['require','durandal/app','i18next'],function (require) {
    var app = require('durandal/app');
    var i18n = require('i18next');

    var saveBannerOptions = {
        classes: 'alert-success',
        iconClasses: 'togo-icon togo-icon-check',
        message: i18n.t('settings.success'),
        removeOnNavigation: true
    };

    return {
        initialize: function () {
            app.on('settings:save').then(function () {
                app.trigger('banner:addOne', saveBannerOptions);
            });
        }
    };
});

